module.exports = __webpack_public_path__ + "media/svgs/coffee-aba66b45.svg";